
export const DefaultStatus = { text: 'Unknown', color: 'text.disabled' };

// Ticket
export const TicketStatusMap = {
  0: { text: 'Open', color: 'error.main' },
  1: { text: 'Submitted', color: 'warning.main' },
  2: { text: 'Resolved', color: 'success.main' },
  3: { text: 'Rejected', color: 'primary.main' },
  4: { text: 'Closed', color: 'text.secondary' },
};

// Payment
export const PaymentStatusMap = {
  0: { text: 'Submitted', color: 'warning.main' },
  1: { text: 'Paid', color: 'success.main' },
  2: { text: 'Completed', color: 'success.dark' },
  3: { text: 'Closed', color: 'text.secondary' },
};

// Car
export const CarStatusMap = {
  0: { text: 'Hoạt động', color: 'inherit' },
  1: { text: 'Nằm bãi', color: 'warning.main' },
  2: { text: 'Bảo dưỡng', color: 'error.main' },
};